import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Context } from '../types';

export const useEditorMetaDataStore = defineStore('editor-meta-data', () => {
  const context = ref<Context>(null);

  const setContext = (newContext: Context) => {
    context.value = newContext;
  };

  return {
    setContext,
    context,
  };
});
